import Link from "next/link";

/* Short pre-payment notice that sits directly under a Buy button.
 * Mirrors the text Stripe shows above the Pay button (lib/checkout-disclosure.ts). */
export function CheckoutDisclosure({
  physical = false,
  className = "",
}: {
  /** True for printed/shipped items; false (default) for digital downloads. */
  physical?: boolean;
  className?: string;
}) {
  return (
    <p className={`text-[12px] leading-[1.5] text-white/80 ${className}`}>
      {physical
        ? "Printed and shipped, made to order. Shipping and any tax are shown before you pay."
        : "Digital download: nothing ships. Delivered by link on the next page and by email. The price shown is the total; any tax is added on the Stripe checkout page before you pay."}{" "}
      By continuing you agree to the{" "}
      <Link href="/legal/terms" className="underline underline-offset-2">Terms</Link>,{" "}
      <Link href="/legal/refund-policy" className="underline underline-offset-2">Refund Policy</Link> and{" "}
      <Link href="/legal/license" className="underline underline-offset-2">License</Link>
      {physical
        ? "."
        : ", and ask us to deliver immediately, so the 14-day cancellation right for digital content ends once the download starts."}
    </p>
  );
}
